import { render } from "./state.vue?vue&type=template&id=72bed168&scoped=true"
import script from "./state.vue?vue&type=script&lang=js"
export * from "./state.vue?vue&type=script&lang=js"

import "./state.vue?vue&type=style&index=0&id=72bed168&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bed168"]])

export default __exports__